/* ============================================================
   Wohnberger – Home Page Interactions
   Vanilla JS, kompatibel mit Shopify Liquid Sections
   ============================================================ */
(function () {
  "use strict";

  /* ===== Mega-Menü ===== */
  function initMegaMenu() {
    document.querySelectorAll('[data-wb-nav-item]').forEach((item) => {
      item.addEventListener('mouseenter', () => item.classList.add('wb-home-is-open'));
      item.addEventListener('mouseleave', () => item.classList.remove('wb-home-is-open'));
    });
  }

  /* ===== FAQ Accordion ===== */
  function hydrateLandingFaq() {
    document.querySelectorAll('.a2m-faq-wrapper').forEach((wrapper) => {
      wrapper.classList.add('wb-home-faq', 'wb-home-faq--shared');
      wrapper.querySelectorAll('.a2m-faq-item').forEach((item, index) => {
        if (item.hasAttribute('data-wb-faq-item')) return;
        const heading = item.querySelector('h3');
        const answer = item.querySelector('[itemprop="acceptedAnswer"]');
        if (!heading || !answer) return;

        item.setAttribute('data-wb-faq-item', '');
        item.classList.add('wb-home-faq-item');
        item.classList.toggle('wb-home-is-open', index === 0);

        const text = heading.textContent.trim();
        heading.textContent = '';
        heading.classList.add('wb-home-faq-heading');

        const button = document.createElement('button');
        button.className = 'wb-home-faq-q';
        button.type = 'button';
        button.setAttribute('data-wb-faq-q', '');
        button.innerHTML = '<span>' + text + '</span><span class="wb-home-faq-toggle" aria-hidden="true">+</span>';
        heading.appendChild(button);

        answer.classList.add('wb-home-faq-a');
        const inner = answer.querySelector('[itemprop="text"]') || answer.firstElementChild || answer;
        inner.classList.add('wb-home-faq-a-inner');
      });
    });
  }

  function initFaq() {
    hydrateLandingFaq();
    document.querySelectorAll('[data-wb-faq-item]').forEach((item) => {
      const btn = item.querySelector('[data-wb-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('wb-home-is-open');
        // optional: nur eines offen
        item.parentElement.querySelectorAll('[data-wb-faq-item].wb-home-is-open')
          .forEach((el) => { if (el !== item) el.classList.remove('wb-home-is-open'); });
        item.classList.toggle('wb-home-is-open', !isOpen);
      });
    });
  }

  /* ===== Hero Konfigurator ===== */
  function initHeroConfigurator() {
    const root = document.querySelector('[data-wb-configurator]');
    if (!root) return;

    const inner = root.querySelector('[data-wb-canvas-inner]');
    const wInput = root.querySelector('[data-wb-w]');
    const hInput = root.querySelector('[data-wb-h]');
    const wVal = root.querySelector('[data-wb-w-val]');
    const hVal = root.querySelector('[data-wb-h-val]');
    const wDim = root.querySelector('[data-wb-dim-w]');
    const hDim = root.querySelector('[data-wb-dim-h]');

    function update() {
      const w = parseInt(wInput.value, 10);
      const h = parseInt(hInput.value, 10);
      if (wVal) wVal.textContent = w + ' cm';
      if (hVal) hVal.textContent = h + ' cm';
      if (wDim) wDim.textContent = w + ' cm';
      if (hDim) hDim.textContent = h + ' cm';
      if (inner) {
        inner.style.aspectRatio = w + '/' + h;
        inner.style.width = Math.min(78, 40 + w / 4) + '%';
      }
    }

    [wInput, hInput].forEach((el) => el && el.addEventListener('input', update));

    root.querySelectorAll('[data-wb-swatch]').forEach((s) => {
      s.addEventListener('click', () => {
        root.querySelectorAll('[data-wb-swatch]').forEach((x) => x.classList.remove('wb-home-is-active'));
        s.classList.add('wb-home-is-active');
        if (inner) inner.style.backgroundImage = s.dataset.gradient;
      });
    });

    update();
  }

  /* ===== Scroll Reveal ===== */
  function initReveal() {
    const els = document.querySelectorAll('.wb-home-wb-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('wb-home-is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('wb-home-is-in'); });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  /* ===== Init ===== */
  function init() {
    initMegaMenu();
    initFaq();
    initHeroConfigurator();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
